/**
 * usePermissions — role-based permission helpers.
 */

import { useAuthStore } from "@/stores/authStore";
import type { UserRole } from "@/types";

export function usePermissions() {
  const role = useAuthStore((s) => s.user?.role ?? null);

  /** Check if the current user has one of the listed roles. */
  const hasRole = (...allowedRoles: UserRole[]): boolean => {
    if (!role) return false;
    return allowedRoles.includes(role as UserRole);
  };

  const isAdmin = role === "admin";
  const isManager = role === "manager" || role === "admin";
  const isAccountant = role === "accountant";
  const isHR = role === "hr";
  const isCleaner = role === "cleaner";

  return { role, hasRole, isAdmin, isManager, isAccountant, isHR, isCleaner };
}
